exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .mat-dialog-container {\n  padding: 0 !important; }\n\n.mat-dialog-content {\n  margin: 0; }\n\n.bold-text {\n  font-weight: bold; }\n\n.margin-left-4 {\n  margin-left: 4px; }\n\np {\n  font-size: 12px;\n  margin: 12px 0 12px 5px; }\n\n.rewiew-dashboar-body {\n  padding: 24px;\n  background-color: #f2f2f2 !important; }\n  .rewiew-dashboar-body .mayor-card {\n    margin: 8px;\n    padding: 16px !important; }\n    .rewiew-dashboar-body .mayor-card .mayor-comment {\n      display: -ms-flexbox;\n      display: flex;\n      margin-left: 20px; }\n\n.comment-card {\n  margin: 8px; }\n  .comment-card .realisable {\n    display: -ms-flexbox;\n    display: flex;\n    font-size: 12px !important; }\n\n.actions {\n  margin: 8px; }\n\n.employee-comment {\n  margin: 8px 0;\n  font-size: 12px !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/review-results-dialog/review-results-dialog.component.scss
// module id = ../../../../../src/app/components/admin/components/shared/petition-details/dialogs/review-results-dialog/review-results-dialog.component.scss
// module chunks = main